export default "__VITE_ASSET__BaP$XQ89__";